import { createSlice } from '@reduxjs/toolkit'
import authService from '../services/Login'

const jwtConfig = authService.jwtConfig

const initialState = {
    email: '',
    name: '',
    rol: '',
    surname: '',
    rolePermissions: [],
    username: ''
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, { payload }) => {
            localStorage.setItem('dataUser', JSON.stringify(payload))
            localStorage.setItem(jwtConfig.storageTokenKeyName, payload.token)
            return { ...state, ...payload }
        },
        logout: (state) => {
            localStorage.removeItem('dataUser')
            localStorage.removeItem(jwtConfig.storageTokenKeyName)
            localStorage.removeItem('actionsPermission')
            return { ...state, ...initialState }
        }
    }
})

export const { login, logout } = authSlice.actions
export default authSlice.reducer
